import React, { ReactNode } from 'react';
import BreadcrumbNav from '../BreadcrumbNav';

interface PageContentProps {
  children: ReactNode;
}

/**
 * PageContent Component
 * 
 * Wraps content with common page elements like breadcrumb navigation.
 * This helps maintain consistency across different pages.
 */
const PageContent: React.FC<PageContentProps> = ({ children }) => {
  return (
    <div className="page-content-wrapper">
      <div className="breadcrumb-container">
        <BreadcrumbNav />
      </div>
      <div className="page-content">
        <div className="content-container">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageContent;
